<template>
  <canvas :id="id + 'qr'" ref="qr"></canvas>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";
import { PropOptions } from "vue";
import QRCode from "qrcode";

@Component({ name: "cat-qr" })
export default class CarQR extends Vue {
  @Prop({
    type: String,
    default: "",
    description: "The url to display"
  } as PropOptions<any>)
  readonly url?: string;
  @Prop({
    type: String,
    default: "",
    description: "The id to display"
  } as PropOptions<any>)
  readonly id?: string;
  @Prop({
    type: String,
    description:
      "Accessible name for the icon. By default, the icon name is used."
  } as PropOptions<any>)
  readonly iconLabel?: string;
  @Prop({
    type: Boolean,
    default: true,
    description:
      "The icon is purely decorative and does not provide value for assistive technology."
  } as PropOptions<any>)
  readonly decorative?: boolean;

  mounted() {
    QRCode.toCanvas(this.$refs.qr, this.url, function (error) {
      if (error) console.error(error);
      console.log("success!");
    });
  }
}
</script>
